<template>
  <div class="p-4 border rounded-xl">
    <div class="flex items-center gap-4 mb-4">
      <img v-if="item.attributes.main_image" :src="item.attributes.main_image" class="object-cover aspect-square w-16 rounded-xl" />
      <div v-else class="aspect-square w-16 flex items-center shrink-0 justify-center rounded-xl bg-gray-100">
        <span class="fa-stack text-[24px] opacity-20 ">
          <i class="fa-image far fa-stack-1x" aria-hidden="true"></i>
          <i class="fa-slash fas icon-stack-base fa-stack-1x " aria-hidden="true"></i>
        </span>
      </div>
      <h6 class="block truncate font-bold">{{ item.attributes.name }}</h6>
      <div class="ml-auto text-xl font-bold shrink-0">
        {{ item.attributes.currency_symbol }}
        {{ item.attributes.price }}
      </div>
    </div>
    <button v-if="!added" class="jt-btn btn-secondary jt-mk-btn w-full" @click="$emit('addItem', item.id)">
      {{ i18n.t('marketplace.general.add_item') }}
    </button>
    <div v-if="added" class="text-green-600 font-bold mt-2 text-center w-full">
      {{ i18n.t('marketplace.items_show.added_to_cart') }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    addedItems: {  
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    added() {
      return this.addedItems.includes(parseInt(this.item.id, 10));
    }
  }
}
</script>
